// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__kNITb","list":"BalanceDue_list__3_m2z","listRow":"BalanceDue_listRow__1Shnu","total":"BalanceDue_total__3k6RG"};